import React, { useImperativeHandle, forwardRef, useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  makeStyles,
  Box,
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'; // Ícone amigável de pergunta

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 16,
    padding: theme.spacing(1),
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: theme.spacing(3),
  },
  iconContainer: {
    backgroundColor: 'rgba(0, 159, 214, 0.1)',
    borderRadius: '50%',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: 40,
    color: '#009FD4',
  },
  title: {
    fontWeight: 'bold',
    color: '#333',
    textAlign: 'center',
  },
  content: {
    textAlign: 'center',
    padding: theme.spacing(2, 4),
  },
  actions: {
    justifyContent: 'center',
    padding: theme.spacing(2, 3, 3),
    gap: theme.spacing(2),
  },
  btnConfirmar: {
    borderRadius: 8,
    padding: '8px 30px',
    backgroundColor: '#009FD4',
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#007ca5',
    },
  },
  btnCancelar: {
    borderRadius: 8,
    padding: '8px 30px',
    fontWeight: 'bold',
    textTransform: 'none',
    color: '#757575',
  },
}));

const DialogoConfirmacao = forwardRef(
  ({ handleConfirma, handleRejeita = () => {} }, ref) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [codigo, setCodigo] = useState(0);

    useImperativeHandle(ref, () => ({
      handleOpen(titleNew, contentNew, codigoNew) {
        setTitle(titleNew);
        setContent(contentNew);
        setOpen(true);
        setCodigo(codigoNew);
      },
    }));

    const handleClose = () => {
      setOpen(false);
      handleRejeita(codigo);
    };

    const handleSalvar = () => {
      setOpen(false);
      handleConfirma(codigo);
    };

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        classes={{ paper: classes.paper }}
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        fullWidth
      >
        {/* Cabeçalho centralizado com ícone */}
        <Box className={classes.header}>
          <div className={classes.iconContainer}>
            <HelpOutlineIcon className={classes.icon} />
          </div>
          <Typography variant="h6" className={classes.title}>
            {title || 'Confirmação'}
          </Typography>
        </Box>

        <DialogContent className={classes.content}>
          <DialogContentText style={{ color: '#666' }}>
            {content}
          </DialogContentText>
        </DialogContent>

        <DialogActions className={classes.actions}>
          <Button
            onClick={handleClose}
            className={classes.btnCancelar}
            tabIndex={-1} // Seguindo sua preferência de tabIndex
          >
            Não
          </Button>
          <Button
            onClick={handleSalvar}
            variant="contained"
            className={classes.btnConfirmar}
            autoFocus
            tabIndex={-1}
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    );
  },
);

export default DialogoConfirmacao;
